// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Poppins', 'Poppins Fallback'","fontStyle":"normal"},"className":"__className_4ca182"};